import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import useExtensionHeartbeat from "~/client/hooks/useExtensionHeartbeat";
const ExtensionContext = createContext({
    isInstalled: null,
    version: null,
});
export const ExtensionProvider = ({ children }) => {
    const { data, isError } = useExtensionHeartbeat();
    const value = isError
        ? {
            isInstalled: false,
            version: null,
        }
        : (data === null || data === void 0 ? void 0 : data.version) === undefined
            ? { isInstalled: null, version: null }
            : {
                isInstalled: true,
                version: data.version,
            };
    return (_jsx(ExtensionContext.Provider, { value: value, children: children }));
};
export const useExtensionContext = () => useContext(ExtensionContext);
